import slugify from 'slugify'

export const generateFaqSlug = (title: string): string => {
  if (!title) {
    return ''
  }
  return `faq-` + slugify(title).toLowerCase()
}
